import { mutationTypes } from './mutations';
import api from './api'

export const actionTypes = {
	contactsLoad: 'contactsLoad',
	contactsCreate: 'contactsCreate',
	contactsDestroy: 'contactsDestroy',
	contactsValidate: 'contactsValidate',
	contactsTestEmail: 'contactsTestEmail'
};

export default {
	[actionTypes.contactsLoad]({ commit }) {
		return api.contactsLoad()
			.then(data => commit(mutationTypes.CONTACTS_LOAD, data))		
	},
	[actionTypes.contactsCreate]({ commit }, contact) {
		return api.contactsCreate(contact)
			.then(({data}) => {
				commit(mutationTypes.CONTACTS_CREATE, data)
				return data
			})
	},	
	[actionTypes.contactsDestroy]({ commit }, file) {
		return api.contactsDestroy(file)
			.then(data => commit(mutationTypes.CONTACTS_DESTROY, file))
	},
	[actionTypes.contactsValidate]({ state }, contact) {
		return new Promise((resolve, reject) => {
			const validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
			const res = {
				isValid: true,
				messages: [],
				...contact
			}	
			if (contact.fullname.length < state.validation.fullname.min ||
				contact.fullname.length > state.validation.fullname.max) {
				res.isValid = false
				res.messages.push({
					key: 'fullname',
					error: 'This name is an odd length. Should be between 3 and 50 characters long.'
				})
			}
			if (!contact.email.match(validRegex)) {
				res.isValid = false
				res.messages.push({
					key: 'email',
					error: 'This email is not correct.'
				})
			}
			if (contact.phone.length < 10 || contact.phone.length > 20) {
				res.isValid = false
				res.messages.push({
					key: 'phone',
					error: 'This telephone number does not look correct.'
				})
			}
			if (contact.company.length > 50) {
				res.isValid = false
				res.messages.push({
					key: 'company',
					error: 'This company name seems too long.'
				})
			}
			if (contact.message.length < state.validation.message.min ||
				contact.message.length > state.validation.message.max) {
				res.isValid = false
				res.messages.push({
					key: 'message',
					error: 'This message is an odd length. Should be between 10 and 5,000 characters long.'
				})
			}	

			resolve(res)
		})
	},
	[actionTypes.contactsTestEmail]() {
		return api.contactsTestEmail()
	}
};
